import script from "./CMD00720.vue?vue&type=script&setup=true&lang=ts"
export * from "./CMD00720.vue?vue&type=script&setup=true&lang=ts"

import "./CMD00720.vue?vue&type=style&index=0&id=67a780ec&scoped=true&lang=css"
import "./CMD00720.vue?vue&type=style&index=1&id=67a780ec&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67a780ec"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QBtn,QField});
